import React from 'react';
import Title from 'components/TitleWithIcon';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import {useStyles} from './style';
import StepperCaptacionDeFallecidos from './Stepper'
import { DialogContent, AppBar, Toolbar, Typography, Button } from '@material-ui/core';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function AlertDialogSlide(props) {
    const classes = useStyles();
    const cerrar = () => {
        props.handleClose()
        props.MODULO_FALLECIDOS_SET_STEPPER(0);
    }
    return (
        <div>
            <Dialog     open={props.open}
                        fullScreen 
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={props.handleClose}
                        aria-labelledby="alert-dialog-slide-title"
                        aria-describedby="alert-dialog-slide-description"
            >
                <AppBar className={classes.appBar} elevation={0}>
                    <Toolbar >
                        <Typography variant="h6" className={classes.title}> Captación de fallecidos</Typography>          
                        <Button autoFocus color="inherit" onClick={cerrar}> Cerrar</Button>
                    </Toolbar>                
                </AppBar>
                <DialogContent className={classes.dialogContent}>
                    <Title title="Captación de fallecidos" icon={"/menu/partner.svg"}/>
                    <StepperCaptacionDeFallecidos open={props.open} handleClose={props.handleClose} actualizarTabla={props.actualizarTabla} vacio=""/>
                </DialogContent>
            </Dialog>
        </div>
    );
}
export default connect(mapStateToProps, mapDispatchToProps)(AlertDialogSlide);